import type { RouteLocationNormalizedGeneric } from '#vue-router'

import { useDisciplineStore } from '@stores/discipline'

import { useDisciplineCustomerGoApi } from '@api/discipline/customer-go.hook'
import { useDisciplineContext } from '@hooks/discipline/discipline-context.hook'
import { useDisciplinePrivileges } from '@hooks/discipline/discipline-privileges.hook'

import { defineNuxtRouteMiddleware } from '#app'

/** The General info title ("Goal") and the Kanban log customer badge need the customer flags. They need the customer
 *  id from the shared read, so the read is chained on it (never awaited) and done once per customer. */
export default defineNuxtRouteMiddleware((to: RouteLocationNormalizedGeneric) => {
  const disciplineId = to.params.id

  if (typeof disciplineId !== 'string' || !disciplineId) return

  const disciplineStore = useDisciplineStore()
  const { canViewCustomers } = useDisciplinePrivileges()

  void useDisciplineContext().whenReady(disciplineId).then(() => {
    const customerId = disciplineStore.getCustomerId
    if (!customerId || !canViewCustomers.value || disciplineStore.getCustomerGoId === customerId) return

    disciplineStore.setCustomerGoId(customerId)
    void useDisciplineCustomerGoApi({ customerId })
  })
})
